import React from 'react';
import './EJournals.css';
import LibraryNavbar from '../../components/Library/LibraryNavbar';
import Footer from '../../components/Homepage/Footer/Footer';
import journalsData from '../../data/journal';

const EJournals = () => {
  React.useEffect(() => {
    // Set page title
    document.title = 'E-Journals - Central Library - Rayalaseema University';
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  const handleJournalClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div id="ejournals-main-page">
      {/* Library-specific Navigation */}
      <LibraryNavbar />
      
      

      {/* Journals Table Section */}
      <div id="ejournals-content-section">
        <div className="ejournals-container">
          <div className="ejournals-table-wrapper">
            <table className="ejournals-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Journal Title</th>
                  <th>Access Link</th>
                </tr>
              </thead>
              <tbody>
                {journalsData.map(journal => (
                  <tr key={journal.id}>
                    <td className="ejournals-serial">{journal.serialNumber}</td>
                    <td className="ejournals-title">{journal.title}</td>
                    <td className="ejournals-link">
                      <button 
                        onClick={() => handleJournalClick(journal.link)}
                        className="ejournals-access-btn"
                      >
                        Access Journal
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default EJournals;